module.exports = __webpack_public_path__ + "media/images/home/flow_p_3-fee7347ea5581c3c94722fe5a77a9bcb.svg";